const fmt = (v) => Number(v || 0).toFixed(2);

export const INVOICE_TAX_HEADERS = ["Tax", "%", "Value"];

// Taxes were copied onto the invoice at creation and recomputed whenever its
// extra charge, discount or deduction changes; total already includes all of them.
export const invoiceTaxTotals = (invoice) => {
  const taxTotal = (invoice?.taxes ?? []).reduce((sum, t) => sum + Number(t.amount || 0), 0);
  const total = Number(invoice?.total || 0);
  const extraCharge = Number(invoice?.extra_charge_amount || 0);
  const discount = Number(invoice?.discount_amount || 0);
  const deduction = Number(invoice?.deduction_amount || 0);
  const beforeTaxes = total - taxTotal;
  return {
    subtotal: beforeTaxes - extraCharge + discount + deduction,
    extraCharge,
    discount,
    deduction,
    beforeTaxes,
    taxTotal,
    total,
  };
};

// Table rows for the taxes an invoice was created with.
const InvoiceTaxRows = ({ taxes = [] }) =>
  taxes.length ? (
    taxes.map((t) => (
      <tr key={t.id} className="border-b border-gray-100 hover:bg-gray-50">
        <td className="py-2 pr-4 text-gray-900 whitespace-nowrap">{t.name}</td>
        <td className="py-2 pr-4 text-gray-700">
          {t.type === "percentage" ? `${Number(t.rate)}%` : <span className="text-gray-300">-</span>}
        </td>
        <td className="py-2 pr-4 text-gray-900">{fmt(t.amount)}</td>
      </tr>
    ))
  ) : (
    <tr>
      <td colSpan={INVOICE_TAX_HEADERS.length} className="py-3 text-xs text-gray-400">
        No taxes applied.
      </td>
    </tr>
  );

export default InvoiceTaxRows;
